import { render, staticRenderFns } from "./speaker-card.vue?vue&type=template&id=35be9c0a&scoped=true&"
import script from "./speaker-card.vue?vue&type=script&lang=js&"
export * from "./speaker-card.vue?vue&type=script&lang=js&"
import style0 from "./speaker-card.vue?vue&type=style&index=0&id=35be9c0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35be9c0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35be9c0a')) {
      api.createRecord('35be9c0a', component.options)
    } else {
      api.reload('35be9c0a', component.options)
    }
    module.hot.accept("./speaker-card.vue?vue&type=template&id=35be9c0a&scoped=true&", function () {
      api.rerender('35be9c0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/elements/speaker-card.vue"
export default component.exports